module.exports = __webpack_public_path__ + "bcd7922441647f111c6118f167bd786d.svg";